export const breadcrumbTokens = {
  'breadcrumb-font-size': 'var(--dp-font-size-sm)',
  'breadcrumb-color': 'var(--dp-color-text-secondary)',
  'breadcrumb-active-color': 'var(--dp-color-text)',
  'breadcrumb-active-weight': 'var(--dp-font-weight-medium)',
  'breadcrumb-separator': '"/"',
  'breadcrumb-separator-color': 'var(--dp-color-text-tertiary)',
  'breadcrumb-gap': 'var(--dp-spacing-sm)',
  'breadcrumb-link-hover': 'var(--dp-color-primary)',
} as const;
